import React from 'react';
import { Navigate } from 'react-router-dom';
import { hasPermission, User } from '../../utils/permissions';

interface PermissionRouteProps {
  user: User | null;
  page: string;
  action: string;
  children: React.ReactNode;
  fallback?: React.ReactNode;
}

const PermissionRoute: React.FC<PermissionRouteProps> = ({
  user,
  page,
  action,
  children,
  fallback
}) => {
  const hasAccess = hasPermission(user, page, action);
  
  if (!hasAccess) {
    if (fallback) {
      return <>{fallback}</>;
    }
    
    return (
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '400px',
        flexDirection: 'column',
        color: '#999'
      }}>
        <div style={{ fontSize: 48, marginBottom: 16 }}>🔒</div>
        <div style={{ fontSize: 18, marginBottom: 8 }}>访问受限</div>
        <div style={{ fontSize: 14 }}>您没有权限访问此页面</div>
      </div>
    );
  }
  
  return <>{children}</>;
};

export default PermissionRoute;
